import React from "react"
import { View, StyleSheet } from "react-native"
import FunnelStepTicks from "./FunnelStepTicks"

/**
 * La recherche des masteurs, mise en scène.
 *
 * Les critères de l'élève se cochent (sa classe, ses créneaux, son objectif) :
 * c'est ce qu'on cherche, dit avec ses mots. Pendant ce temps, le vivier —
 * de vrais visages, servis par le matching — se pose dans le bandeau de la
 * scène, visage après visage ({@see tutorFacesScene}) ; les deux retenus s'y
 * distinguent quand la recherche se termine. Puis les cartes.
 */
const FIELD_SLOTS = [
    [0.06, 0.16],
    [0.3, 0.04],
    [0.55, 0.2],
    [0.82, 0.06],
    [0.14, 0.58],
    [0.4, 0.46],
    [0.66, 0.62],
    [0.9, 0.44],
    [0.02, 0.92],
    [0.3, 0.84],
    [0.58, 0.96],
    [0.84, 0.86],
]
const FIELD_HEIGHT = 170
const FACE = 34

const FunnelTutorSearch = ({ criteria, found, onDone }) => (
    <View style={styles.wrap}>
        <FunnelStepTicks
            lines={criteria}
            done={found}
            onFinished={onDone}
            holdMs={520}
        />
    </View>
)

const styles = StyleSheet.create({
    wrap: { paddingTop: 6 },
})

export default FunnelTutorSearch
